import { Localization } from "@viamap/viamap2-common";
import { ReactNode } from "react";
import { BsHouseDoor } from "react-icons/bs";
import { MIBIcon } from "src/componentsUtils/MIBIcon";

export function JPBLegendList() {
  return (
    <div className="Group" key="JPBLegend">
      <div className="Line">
        <div className="TitleIcon">
          <MIBIcon icon="JPB" />
        </div>
        <div className="Title">
          <b>{Localization.getText("JPB symbols")}</b>
        </div>
      </div>

      <JPBLegendRow
        label={Localization.getText("Not selected")}
        circleColor="#606060"
      />
      <JPBLegendRow
        label={Localization.getText("Selected")}
        circleColor="#3a8e87"
      />
      <JPBLegendRow
        label={Localization.getText("Has building selected")}
        circleColor="#3a8e87"
        overlay={<BsHouseDoor size={11} />}
      />
      <JPBLegendRow
        label={Localization.getText("Has building not selected")}
        circleColor="#606060"
        overlay={<BsHouseDoor size={11} />}
      />
      <JPBLegendRow
        label={Localization.getText("Has building locked")}
        circleColor="#1f1f1f"
        overlay={<BsHouseDoor size={11} />}
      />
      <JPBLegendRow
        label={Localization.getText("Issue")}
        circleColor="#1f1f1f"
        overlay="!"
      />
    </div>
  );
}

function JPBLegendRow(props: { label: string; circleColor: string; overlay?: ReactNode }) {
  return (
    <div className="Line">
      <div className="Color">
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: props.circleColor,
            border: "2px solid #ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1
          }}
        >
          {props.overlay}
        </div>
      </div>
      <div className="Operator"></div>
      <div className="Text" style={{ textAlign: "left" }}>
        {props.label}
      </div>
      <div className="Count"></div>
    </div>
  );
}
